import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import { select } from '@swf/core/store';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import styles from '../../styles/csf.scss';
import type { Category } from '../../types/category';

import {
  TXTWCL_For_more_information_read_the__ELL,
  TXTWCL_PokerStars_Frequently_Asked_Qu_ELL,
  TXTWCL_Your_question_may_be_already_a_ELL
} from './Faq.messages.json';

interface Props {
  category: Category | undefined;
  subCategory: Category | undefined;
}

const regFormatUrl = /[`~!@#$%^&*()|+=?;:'",.<>{}[\]\\/]/gi;
const regRemoveSpace = /\s+/g;

const Faq: React.FC<Props> = ({ category, subCategory }) => {
  const brand = useSelector(select.cms.getBrandName);

  const normalize = (category?: Category) =>
    category
      ? category.name.replace(regFormatUrl, '').replace(regRemoveSpace, '').toLowerCase()
      : 'none';

  return (
    <>
      <div className={styles.info}>
        <Translation
          tagName="span"
          {...TXTWCL_Your_question_may_be_already_a_ELL}
          values={{ 0: brand }}
        />
      </div>
      <Translation
        tagName="p"
        {...TXTWCL_For_more_information_read_the__ELL}
        values={{
          1: <Translation tagName="span" {...TXTWCL_PokerStars_Frequently_Asked_Qu_ELL} />,
          a: (msg: React.ReactNode) => (
            <ResolverLink resolverTag={`df_${normalize(category)}_${normalize(subCategory)}`}>
              {msg}
            </ResolverLink>
          )
        }}
      />
    </>
  );
};

export default Faq;
